
import { defineComponent } from 'vue'
import { RouteRecordNormalized, useRouter } from 'vue-router'
import { useLog } from '@/hooks'
import { useGlobal } from '@/hooks'

export default defineComponent({
  setup() {
    // eslint-disable-next-line
    const l = useLog()
    const { globalData } = useGlobal()
    const { getRoutes, currentRoute } = useRouter()
    // 筛选出要在Header上显示的按钮(meta.hideInHeader=true的不显示)
    const allRoutes: Array<RouteRecordNormalized> = getRoutes().filter(
      (r) => !r.meta.hideInHeader
    )

    return {
      allRoutes,
      currentRoute,
      globalData,
    }
  },
})
